import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Spinner, Table } from "reactstrap";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Container from "../../../components/Container";
import AppLayout from "../../../components/layouts/AppLayout";
import API from "../../../utils/API";
import Create from "./Create";
import Delete from "./Delete";
import Edit from "./Edit";

const Index = () => {
  const [courses, setCourses] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchCourses = async () => {
    try {
      const data = (await API.get("/api/courses")).data.data;
      setCourses(data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, [refresh]);

  return (
    <AppLayout>
      <Breadcrumbs
        title="Courses"
        links={[
          {
            title: "Dashboard",
            link: null,
          },
          {
            title: "Courses",
            link: null,
          },
        ]}
      />
      <Container>
        <Card className="border-0 shadow mt-5" style={{ minHeight: "70vh" }}>
          <CardBody>
            <div className="d-flex align-items-center justify-content-between mb-4">
              <h1 className="mb-0">All Courses</h1>
              <Create course={courses} fetchCourses={fetchCourses} />
            </div>
            <Table hover responsive>
              <thead>
                <tr className="bg-shade-blue">
                  <th>#</th>
                  <th>Name</th>
                  <th>Course Code</th>
                  <th>Department</th>
                  <th>Prerequisite Course</th>
                  <th>Credit Hours</th>
                  <th>Active</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {courses.length > 0 ? (
                  courses.map((course, index) => (
                    <tr
                      key={`course-${course.id}`}
                      style={{ verticalAlign: "middle" }}>
                      <th scope="row">{index + 1}</th>
                      <td>{course.name}</td>
                      <td>{course.course_code}</td>
                      <td>{course.relationships.department.name}</td>
                      {course.prerequisite_course_id ? (
                        <td>{course.relationships.prerequisite.name}</td>
                      ) : (
                        <td>-</td>
                      )}
                      <td>{course.credit_hours}</td>
                      {course.is_active == 1 ? <td>Yes</td> : <td>No</td>}
                      <td>
                        <Edit course={course} fetchCourses={fetchCourses} />
                        <Delete
                          course={course}
                          refresh={refresh}
                          setRefresh={setRefresh}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={10} className="text-center">
                      {loading ? (
                        <Spinner style={{ width: "30px", height: "30px" }} />
                      ) : (
                        "No Courses Exists"
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Container>
    </AppLayout>
  );
};

export default Index;
